<template>
  <div>
    <h5>What Is An ICO?</h5>
    <p>
      ICO stands for Initial Coin Offering, also known as “token sale” or
      crowdsale. It is an unregulated fundraising method for startups. Start-up
      companies use these funds to further develop and complete their blockchain
      based software projects. It is similar to IPO ( Initial Public Offering),
      in which investors purchase shares of a company.
    </p>
    <p>
      Initial Coin Offerings offer “Tokens” in return for users who support them
      by sending them Ether. When you give these ICO teams your ETH/BTC or other
      currencies, it means that you believe that these technologies they are
      creating will bring value to the Ethereum Community.
    </p>
    <p>
      In the beginning of an ICO, the leading team will explain their vision and
      will normally provide a White Paper. This White Paper contains a lot of
      valuable information that you should read, even if you do not understand a
      lot of the technical terms, as long as you get a basic understanding of
      what the Token is about, it will help in your decision making.
    </p>
    <p>
      Take note of the team and web developers behind the ICO. Reputable
      programmers and business people usually mean that the ICO is legitimate
      and that it has a lot of potential. Sometimes, these teams recruit well
      known Facebook developers or managers/Google employees, this is when you
      know that the Token Team is truly creating something valuable.
    </p>
    <p>
      It is crucial to do your research on an ICO that you are interested in.
      The ICO hype in the community has caused many people and fake companies to
      create “Scam ICOS” simply because it is easy to raise money due to the
      “hype” created around the token. Scam ICOs usually execute the “pump and
      dump” method for gaining maximum profits. Creating hype around a token is
      fairly easy to do, and you should try your best not to let FOMO (Fear Of
      Missing Out) cloud your judgement. Hype can be easily created through
      posts on Reddit/Facebook/Slack etc, by people who are looking make quick
      bank with the pump and dump method.
    </p>
    <p>
      Pump and Dump (when a token hits exchanges): When a token is full of hype
      and no backbone or actual real world value, a lot of people will ride the
      hype wave up. Everyone will see that the token is performing exceptionally
      well on exchanges and buy in, but there are also people who are ready to
      dump massive amounts of the token back into the exchanges (hundreds of
      thousands of dollars worth of the token, sometimes millions of dollars
      worth). Selling massive amounts of tokens back into the market causes the
      price to plummet, and then everyone else starts to panic and they sell off
      to cut of loses.
    </p>
    <p>
      The value of tokens, ETH, BTC, the price is all driven by the market. You
      have the ability to make the price go up, or go down. It follows the
      supply and demand economic concept. If there are more people who want a
      token, but there is a limited supply of the token, the price increases. If
      no one wants the token, there is a surge of supply avaiable on the market,
      then the price decreases.
    </p>
    <p>
      There are many successful and truly valuable technologies and concepts
      that have come out of ICOs, and that is a good thing. But you must always
      remain vigilant and do a lot of research before investing in anything.
    </p>
    <p>
      After doing your own research and making a decision that a token is worth
      investing in, the next steps are to buy into the ICO.
    </p>
    <p>
      For more information please refer to :
      <a
        href="https://kb.myetherwallet.com/best-of/how-not-to-miss-out-on-ico.html"
        target="_blank"
        rel="noopener noreferrer"
        >Best Ways to Avoid Missing Out On That ICO</a
      >
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
@import 'FaqContents.scss';
</style>
